export default "__VITE_ASSET__Da6f7up6__"